import React, { useContext, useState } from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import { observer } from 'mobx-react'
import { NavLink } from 'react-router'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import clsx from 'clsx'
import { MemberSummary } from '@Entities/member/member-summary'
import useRightsholderReset from '@App/services/useRightsholderReset'

const RightsholderTrayMobile = () => {
    const { rightsholderStore, rightsholderSearchStore } = useContext(StoresContext)
    const [selectIsOpen, setSelectIsOpen] = useState(false)
    const resetRightsholder = useRightsholderReset()

    const allDoneRightsHolders = rightsholderSearchStore.rightsholders
    const currentRightsHolderId = rightsholderStore.optionalCurrentRightsholderId
    const currentRightsHolder = rightsholderStore.currentRightsholder

    if (!allDoneRightsHolders) {
        return null
    }
    const rightsHolderCount = rightsholderSearchStore.rightsholderCount

    return (
        <div className="rightsholders-tray-mobile-component">
            <div className="rightsholders-tray-selector" onClick={() => setSelectIsOpen(!selectIsOpen)}>
                <img src={ICONS.account} alt="Accounts" />
                <h3>
                    {currentRightsHolder ? currentRightsHolder.name : 'Select RH'}
                    <span className="bold">{rightsHolderCount}</span>
                </h3>
                <img
                    src={selectIsOpen ? ICONS.chevron_drop_down : ICONS.chevron_drop_up}
                    alt={!selectIsOpen ? 'Open' : 'Close'}
                />
            </div>
            {selectIsOpen && (
                <div className="rightsholders-tray-list">
                    {allDoneRightsHolders &&
                        allDoneRightsHolders.content.map((data: MemberSummary) => {
                            const linkClass = clsx(
                                'rightsholders-tab',
                                currentRightsHolderId === data.ipId && 'current'
                            )
                            return (
                                <NavLink
                                    to={Navigation.rightholder.summary(data.ipId)}
                                    className={linkClass}
                                    key={data.ipId}
                                    onClick={() => resetRightsholder()}
                                >
                                    <div className="name-block">
                                        <h3>{data.name}</h3>
                                    </div>
                                    <div className="radio-trigger" />
                                </NavLink>
                            )
                        })}
                </div>
            )}
        </div>
    )
}

export default observer(RightsholderTrayMobile)
